import * as React from 'react';

export const PageNotFound: React.FunctionComponent = () => {
    return (
        <div className='container'>
            <h2>Page not found.</h2>
        </div>
    );
};
